import {v4 as uuidv4} from 'uuid';

export function useSections(saveCallback) {
    const sectionTypeWrapper = 0;
    const sectionTypeContent = 1;

    const addSection = (parent, type) => {
        parent.push({
            uuid: uuidv4(),
            name: (type === sectionTypeWrapper ? 'Wrapper section ' : 'Content section ')
                + (parent.length + 1).toString(),
            section_type: type,
            order: parent.length,
            shown: true,
            blocksChanged: true,
            blocks: [],
            subsections: [],
        })
        saveCallback();
    };

    const removeSection = (parent, index) => {
        parent.splice(index, 1);
        saveCallback();
    }

    const cloneSection = (section, parent) => {
        let clonedSection = _.cloneDeep(section);
        parent.push({
            ...clonedSection,
            id: null,
            uuid: uuidv4(),
            blocksChanged: true,
            blocks: cloneBlocks(clonedSection),
            subsections: cloneSubsections(clonedSection),
        });
        saveCallback();
    }

    const cloneSubsections = (section) => {
        return section?.subsections?.map((subsection) => ({
            ...subsection,
            id: null,
            uuid: uuidv4(),
            blocksChanged: true,
            blocks: cloneBlocks(subsection),
        })) ?? []
    }

    const cloneBlocks = (section) => {
        return section?.blocks?.map((block) => ({
            ...block,
            uuid: uuidv4(),
        })) ?? []
    }

    return {
        sectionTypeWrapper,
        sectionTypeContent,
        addSection,
        removeSection,
        cloneSection
    }
}
